<p-dialog  [(visible)]="displayBillPay" [modal]="true" [responsive]="true"
  [closable]="false" [style]="{width: '80vw'}" (onHide)="resetDialog()" [focusOnShow]="false">
  <ng-template pTemplate="header">
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
       <h5 class="p-mb-0">Pay Bills Information</h5>
        <div style="display: flex; align-items: center;">
            <div>
                <strong [ngClass]="'status-open'" *ngIf="statementMessege">{{statementMessege}}</strong>
            </div>
        </div>
    </div>
</ng-template>
  <form [formGroup]="paymentForm">
    <div class="header">
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[0]?.isChecked">
          <span style="color: red;" class="p-mr-2">*</span>
          <div style="flex-grow: 1;">
            <p-dropdown [options]="allVendorsDD" formControlName="vendorId" optionLabel="vendorName" 
              placeholder="Select Vendor" [filter]="true" appendTo="body">
              <ng-template let-item pTemplate="selectedItem">
                {{item.vendorName}}
              </ng-template>
            </p-dropdown>
          </div>
        </div>
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
        *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[3]?.isChecked">
          <span style="color: red;" class="p-mr-2">*</span>
          <div style="flex-grow: 1;">
            <p-calendar formControlName="billDate" [minDate]="minDate" [maxDate]="maxDate" appendTo="body"></p-calendar> 
          </div>
          <div class="p-mb-2 p-d-flex p-ai-center p-flex-wrap" *ngIf="isAllowPostingPeriod">
            <!-- <label style="min-width: 120px;">Posting Period<span style="color: red">*</span>:</label> -->
            <span style="color: red">*</span>
            <div style="flex: 1; max-width: 175px; margin-left: 0;">
            <app-posting-period-selector [transactionDate]="paymentForm?.controls?.billDate?.value" [moduleName]="'Bill Pay'"
                [selectedPostingPeriod]="currentPostingPeriodInfo" [isViewMode]="false"
                (postingInfoChange)="onPostingInfoChange($event)">
            </app-posting-period-selector>
            </div>
          </div>
        </div>
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[1]?.isChecked">
          <span style="color: red;" class="p-mr-2">*</span>
          <div style="flex-grow: 1;">
            <!-- <p-dropdown [options]="bankAccounts" formControlName="financialAccountId" optionLabel="name"
              placeholder="Select Bank Account" [filter]="true" appendTo="body">
              <ng-template let-item pTemplate="selectedItem">
                {{item.name}} ({{item.balance | number: "1.2-2" | currencySymbol}})
              </ng-template>
              <ng-template let-obj pTemplate="item">
                {{obj.name}} ({{obj.balance | number: "1.2-2" | currencySymbol}})
              </ng-template>
            </p-dropdown> -->
            <liono-treeSelect class="border-bottom-input" [options]="bankAccounts" appendTo="body"
            placeholder="Select Bank Account" formControlName="financialAccountId" display="comma"
            [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
          </div>
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[2]?.isChecked">
          <span style="color: red;" class="p-mr-2">*</span>
          <div style="flex-grow: 1;">
            <p-dropdown [options]="vendorPaymentTermsDD" optionLabel="paymentMethodTerm"
              placeholder="Select Payment Term" appendTo="body" [showClear]="true" [filter]="true"
              formControlName="paymentTermId"></p-dropdown>
          </div>
        </div>
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[1]?.isChecked">
          <span style="color: red;" class="p-mr-2">*</span>
          <div style="flex-grow: 1;">
            <p-dropdown [options]="vendorPaymentMethodsDD" optionLabel="paymentMethodMethod"
              placeholder="Select Payment Method" appendTo="body" formControlName="paymentMethodId"
              [filter]="true" 
              (onChange)="setDefaultBankAccount(bankAccounts,this.paymentForm.controls['paymentMethodId'].value?.paymentMethod?.financialAccountId)"></p-dropdown>
          </div>
        </div>
        <div class="p-col-12 p-md-4 p-pb-0 p-d-flex"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_section && billPaymentTemplate.labels_section[4]?.isChecked">
          <div style="flex-grow: 1;margin-left: 0.8rem;">
           <input pInputText formControlName="referenceNumber"  placeholder="Referene Number"/>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12">
          <p-table [value]="rpoList" styleClass="p-datatable-striped">
            <ng-template pTemplate="header">
              <tr>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[0]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[0]?.labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[1]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[1]?.labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[2]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[2].labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[3]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[3]?.labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[4]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[4]?.labelname}}
                </th>
                <th>Credit</th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[5]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[5]?.labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[6]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[6]?.labelname}}
                </th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[7]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[7]?.labelname}}
                </th>
                <th style="width: 2rem">Pay Full Due</th>
                <th
                  *ngIf="billPaymentTemplate && billPaymentTemplate.labels_table && billPaymentTemplate.labels_table[8]?.isChecked">
                  {{billPaymentTemplate && billPaymentTemplate.labels_table &&
                  billPaymentTemplate.labels_table[8]?.labelname}}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
              <tr>
                <td>
                  <p-checkbox binary="true" [(ngModel)]="product.isPay" [ngModelOptions]="{ standalone: true }"
                    (onChange)="deselectRPO(product)"></p-checkbox>
                  {{product.dueDate ? (product.dueDate | date: 'MM/dd/yyyy') : null}}
                </td>
                <td>{{product.rpoNo}}</td>
                <td>{{product.rpoDate ? (product.rpoDate | date: 'MM/dd/yyyy') : null}}</td>
                <td>{{product.totalAmount | customNumberFormat: decimalLength | currencySymbol}}</td>
                <td>{{product.discount | customNumberFormat: decimalLength | currencySymbol}}</td>
                <td>{{product.credit | customNumberFormat: decimalLength | currencySymbol}}</td>
                <td>{{product.actualDueAmount | customNumberFormat: decimalLength | currencySymbol}}</td>
                <td>{{product.paidAmount | customNumberFormat: decimalLength | currencySymbol}}</td>
                <td pEditableColumn>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-inputNumber [(ngModel)]="product.payment" [readonly]="product.payfull" mode="decimal"
                        [minFractionDigits]="2" (focusout)="calculateDue(product)"
                        [ngModelOptions]="{standalone: true}"></p-inputNumber>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{product.payment | customNumberFormat: decimalLength | currencySymbol}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td>
                  <p-checkbox binary="true" [(ngModel)]="product.payfull" (onChange)="payFullDue(product)"
                    [ngModelOptions]="{ standalone: true }"></p-checkbox>
                </td>
                <td>{{product.status ? product.status : null}}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr>
                <td colspan="7" class="p-text-right">{{billPaymentTemplate && billPaymentTemplate.labels_footer &&
                  billPaymentTemplate.labels_footer[0].labelname}}</td>
                <td colspan="3">{{subTotal | customNumberFormat: decimalLength | currencySymbol}}</td>
              </tr>
              <tr
                *ngIf="billPaymentTemplate && billPaymentTemplate.labels_footer && billPaymentTemplate.labels_footer[1]?.isChecked">
                <td colspan="7" class="p-text-right">{{billPaymentTemplate && billPaymentTemplate.labels_footer &&
                  billPaymentTemplate.labels_footer[1]?.labelname}}</td>
                <td colspan="3">
                  <p-inputNumber [disabled]="subTotal<=0" mode="decimal" [minFractionDigits]="2"
                    formControlName="discountAmount" [max]="getMaximumValue()" [min]="0"
                    (focusout)="addDiscount()"></p-inputNumber>
                  <span *ngIf="adjustDiscount" style="color: red;word-break: break-all;">
                    Discount amount exceeds than subtotal, please adjust the discount before submit.
                  </span>
                </td>
              </tr>
              <tr
                *ngIf="billPaymentTemplate && billPaymentTemplate.labels_footer && billPaymentTemplate.labels_footer[1]?.isChecked && paymentForm.controls['discountAmount']?.value>0">
                <td colspan="7" class="p-text-right">
                  <span style="color: red;">*</span>
                  {{billPaymentTemplate && billPaymentTemplate.labels_footer &&
                  billPaymentTemplate.labels_footer[2].labelname}}
                </td>
                <td colspan="3">
                  <liono-treeSelect class="border-bottom-input" [options]="financialAccounts" appendTo="body"
                    placeholder="Select Financial Account" formControlName="discountFinancialAccountId" display="comma"
                    [metaKeySelection]="false" selectionMode="single"></liono-treeSelect>
                </td>
              </tr>
              <!-- <tr>
                  <td colspan="7" class="p-text-right">{{billPaymentTemplate && billPaymentTemplate.labels_footer && billPaymentTemplate.labels_footer[4].labelname}}</td>
                  <td colspan="3">{{orderTotal | number: "1.2-2"}}</td>
                </tr> -->
            </ng-template>
            ` </p-table>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-md-3">
          <div class="p-inputgroup">
            <p class="p-mb-0 p-mt-2">Applied Credit:</p>
            <input pInputText class="no-border" [(ngModel)]="appliedCredit" [ngModelOptions]="{ standalone: true }"
              [disabled]="true" />
            <button type="button" pButton pRipple label="View"
              [disabled]="!paymentForm.controls['vendorId']?.value" (click)="viewAllCredit(false)"></button>
          </div>
        </div>
      </div>
      <div class="p-field p-formgrid p-grid">
        <div class="p-col-12"
          *ngIf="billPaymentTemplate && billPaymentTemplate.labels_message && billPaymentTemplate.labels_message[0]?.isChecked">
          <p-editor placeholder="Memo" [style]="{'height':'50px'}" formControlName="notes"></p-editor>
        </div>
      </div>

      <!-- Custom Section -->
      <div class="p-field p-formgrid p-grid" *ngIf="bill_other1.length>0">
        <ng-container *ngFor="let field of bill_other1; let i=index;">
          <div class="p-col" *ngIf="bill_other1.length>0">
            <div class="card">
              <!-- Custom -->
              <ng-container [ngSwitch]="field.formControl.name">
                <ng-container *ngSwitchCase="'InputBox'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <input [disabled]="isView" pInputText type="text" name="input-{{i}}" #input="ngModel"
                      [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'DropDownList'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" class="small inlineNormalDD"
                      [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" [showClear]="true" [filter]="true"
                      optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                      appendTo="body"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                      [placeholder]="'Select ' +field.name" appendTo="body"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''"
                      optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                    </p-multiSelect>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'CheckBox'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                      <p-checkbox [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                        [ngModelOptions]="{standalone: true}"
                        [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                      </p-checkbox> {{opt.name}}
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'FileUpload'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-fileUpload #refFile name="myfile[]" customUpload="true"
                      (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                      maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                      <ng-template pTemplate="content">
                        <ul *ngIf="field.customUploadedFiles.length">
                          <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                            {{file.name}} - {{file.size}} bytes
                            <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,index)"
                              icon="pi pi-times"></button>
                          </li>
                        </ul>
                      </ng-template>
                    </p-fileUpload>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Picture'">
                  <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-fileUpload #refFile name="myfile[]" customUpload="true"
                      (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                      maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                      <ng-template pTemplate="content">
                        <ul *ngIf="field.customUploadedFiles.length">
                          <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                            {{file.name}} - {{file.size}} bytes
                            <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,i)"
                              icon="pi pi-times"></button>
                          </li>
                        </ul>
                      </ng-template>
                    </p-fileUpload>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'RadioButton'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                      <p-radioButton [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                        [ngModelOptions]="{standalone: true}"
                        [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                      </p-radioButton>&nbsp;{{opt.name}}
                    </ng-container>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Rating'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'ToggleButton'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2" style="width:60%"><span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" [ngModelOptions]="{standalone: true}"
                      offLabel="{{field.labelname}}" [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)"
                      [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="field.value">
                    </p-toggleButton>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'DatePicker'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" appendTo="body"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Decimal'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                      [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                      [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                    </p-inputNumber>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Number'">
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                      [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                    <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                        *ngIf="checkRequired(field.name, bill_other1)">*</span></label>
                    <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="card" *ngIf="bill_other2.length>0">
        <div class="p-field p-formgrid p-grid">
          <ng-container *ngFor="let field of bill_other2">
            <ng-container [ngSwitch]="field.formControl.name">
              <ng-container *ngSwitchCase="'InputBox'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <input pInputText type="text" #input="ngModel" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'DropDownList'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                    [placeholder]="'Select ' +field.name" class="small inlineNormalDD" [showClear]="true"
                    [filter]="true" optionLabel="name" dataKey="name" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}" appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'MultipleDropDownList'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                    [placeholder]="'Select ' +field.name" appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''"
                    optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                  </p-multiSelect>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'CheckBox'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                    <p-checkbox [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                    </p-checkbox> {{opt.name}}
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'FileUpload'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-fileUpload #refFile name="myfile[]" customUpload="true"
                    (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                    maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                    <ng-template pTemplate="content">
                      <ul *ngIf="field.customUploadedFiles.length">
                        <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                          {{file.name}} - {{file.size}} bytes
                          <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,index)"
                            icon="pi pi-times"></button>
                        </li>
                      </ul>
                    </ng-template>
                  </p-fileUpload>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Picture'">
                <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-fileUpload #refFile name="myfile[]" customUpload="true"
                    (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                    maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                    <ng-template pTemplate="content">
                      <ul *ngIf="field.customUploadedFiles.length">
                        <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                          {{file.name}} - {{file.size}} bytes
                          <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,index)"
                            icon="pi pi-times"></button>
                        </li>
                      </ul>
                    </ng-template>
                  </p-fileUpload>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'RadioButton'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                    <p-radioButton [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                    </p-radioButton>&nbsp;{{opt.name}}
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Rating'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'ToggleButton'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2" style="width:60%"><span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" offLabel="{{field.labelname}}"
                    [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)" [offIcon]="'pi pi-times'"
                    iconPos="right" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                  </p-toggleButton>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'DatePicker'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Decimal'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                    [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                    [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                  </p-inputNumber>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Number'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                    [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other2)">*</span></label>
                  <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div class="card" *ngIf="bill_other3.length>0">
        <div class="p-field p-formgrid p-grid">
          <ng-container *ngFor="let field of bill_other3">
            <ng-container [ngSwitch]="field.formControl.name">
              <ng-container *ngSwitchCase="'InputBox'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <input pInputText type="text" #input="ngModel" [(ngModel)]="field.value"
                    [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'DropDownList'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-dropdown [options]="field.pickListValues" [id]="'cf_info'+i" [showClear]="true" [filter]="true"
                    [name]="'cf_info'+i" [placeholder]="'Select ' +field.name" class="small inlineNormalDD"
                    optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                    appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDropdown' : ''"></p-dropdown>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'MultipleDropDownList'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-multiSelect [options]="field.pickListValues" [id]="'cf_info'+i" [name]="'cf_info'+i"
                    [placeholder]="'Select ' +field.name" appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customMultiSelect' : ''"
                    optionLabel="name" dataKey="name" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                  </p-multiSelect>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'CheckBox'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                    <p-checkbox [name]="'cf_chkbx'+i" [value]="opt.name" [(ngModel)]="field.value"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customCheckbox' : ''">
                    </p-checkbox> {{opt.name}}
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'FileUpload'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-fileUpload #refFile name="myfile[]" customUpload="true"
                    (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                    maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                    <ng-template pTemplate="content">
                      <ul *ngIf="field.customUploadedFiles.length">
                        <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                          {{file.name}} - {{file.size}} bytes
                          <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,index)"
                            icon="pi pi-times"></button>
                        </li>
                      </ul>
                    </ng-template>
                  </p-fileUpload>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Picture'">
                <div class="p-col-12 p-lg-4 p-mt-2 p-mb-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-fileUpload #refFile name="myfile[]" customUpload="true"
                    (onSelect)="onCustomUpload($event.files,field,refFile)" multiple="multiple" accept="image/*"
                    maxFileSize="1000000" [showUploadButton]="false" [showCancelButton]="false">
                    <ng-template pTemplate="content">
                      <ul *ngIf="field.customUploadedFiles.length">
                        <li *ngFor="let file of field.customUploadedFiles;let index=index;">
                          {{file.name}} - {{file.size}} bytes
                          <button icon="pi pi-times" pButton type="button" (click)="deleteFile(field,index)"
                            icon="pi pi-times"></button>
                        </li>
                      </ul>
                    </ng-template>
                  </p-fileUpload>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'RadioButton'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <ng-container *ngFor="let opt of field.pickListValues; let j = index;">
                    <p-radioButton [name]="'cf_rdo'+i" [value]="opt.name" [(ngModel)]="field.value"
                      [ngModelOptions]="{standalone: true}"
                      [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRadioButton' : ''">
                    </p-radioButton>&nbsp;{{opt.name}}
                  </ng-container>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Rating'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-rating [cancel]="false" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customRating' : ''"></p-rating>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'ToggleButton'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2" style="width:60%"><span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-toggleButton class="p-mb-2" onLabel="{{field.labelname}}" offLabel="{{field.labelname}}"
                    [onIcon]="'pi pi-check'" (onChange)="setTogleValue(field,$event)" [offIcon]="'pi pi-times'"
                    iconPos="right" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}">
                  </p-toggleButton>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'DatePicker'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2" style="width:60%">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-calendar [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" appendTo="body"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDatePicker' : ''"></p-calendar>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Decimal'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <p-inputNumber [(ngModel)]="field.value" [minFractionDigits]="0"
                    [maxFractionDigits]="(field?.maxLengthAfterDecimal||6)"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customDecimal' : ''"
                    [ngModelOptions]="{standalone: true}" (keypress)="utility.isNumberKey($event)">
                  </p-inputNumber>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'Number'">
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <input pInputText type="text" (keypress)="utility.isNumberKey($event)"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''"
                    [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}" />
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div class="p-col-12 p-lg-4 p-mb-2 p-mt-2">
                  <label class="p-mb-2">{{field.labelname}}<span style="color: red;"
                      *ngIf="checkRequired(field.name, bill_other3)">*</span></label>
                  <input pInputText type="text" [(ngModel)]="field.value" [ngModelOptions]="{standalone: true}"
                    [ngClass]="(field.isRequired && applyValidation && (field.value==null || field.value=='')) ? 'customValidation' : ''" />
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <span class="p-text-center" *ngIf="applyValidation" style="color: red;">Please fill data for all * fields.</span>
    <button type="button" pButton (click)="close()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton class="p-button-success" [disabled]="(isAllowPostingPeriod && !updatedPostingPeriodInfo?.postingDate ) || !paymentForm.valid || isDisabled || !!statementMessege"
      (click)="save(paymentForm.value)" label="Save"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Select Available Credits" [(visible)]="displayCreditSelect" [modal]="true" [responsive]="true"
  [closable]="false" [style]="{ width: '60vw' }" [baseZIndex]="9999">
  <div class="card">
    <div class="p-grid">
      <div class="p-col-12">
        <p-table [value]="availableCredits" [(selection)]="selectedCredits" dataKey="id" selectionMode="multiple">
          <ng-template pTemplate="header">
            <tr>
              <th>Memo No.</th>
              <th>Status</th>
              <th>Create Date</th>
              <th>Create By</th>
              <th>Type</th>
              <th>Total Amount</th>
              <th>Applied Amount</th>
              <th>Available Amount</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
            <tr [pSelectableRow]="product" [pSelectableRowIndex]="rowIndex">
              <td>{{ product.number }}</td>
              <td>{{ product.creditMemoStatus }}</td>
              <td>{{ product.creditMemoDate | date: "MM/dd/yyyy" }}</td>
              <td>{{ product.createdByUser }}</td>
              <td>{{ product.type }}</td>
              <td>{{ product.totalCreditAmount | customNumberFormat: length | currencySymbol }}</td>
              <td>{{ product.appliedAmount | customNumberFormat: length | currencySymbol }}</td>
              <td>{{ product.pendingCreditAmount | customNumberFormat: length | currencySymbol }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="footer" let-product>
            <tr>
              <td colspan="7">
                <div class="p-text-right">Total:</div>
              </td>
              <td>{{ totalAvailCredit | customNumberFormat: length | currencySymbol }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="cancelCredit()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" pButton label="Apply" (click)="applySelectedCredit()"
      [disabled]="availableCredits.length == 0"></button>
  </p-footer>
</p-dialog>
<!-- closing statement -->
<div *ngIf="displayBillPay">
  <app-closing-statement-validation 
  [isClosingDate]="isAllowPostingPeriod ? (updatedPostingPeriodInfo?.postingDate ?? currentPostingPeriodInfo?.postingDate ?? null) : paymentForm?.controls?.billDate?.value" 
  [moduleName]="'Bill Pay'" 
  (isClosingStatementDate)="isClosingStatementDate($event)"></app-closing-statement-validation>
</div>